/* ============================================================
   filter-badge-sync — Sync des Filter-Badge mit AJAX-Updates

   Canvas updated nach Filter-Wechsel nur #filter-results und das
   Facets-Form per AJAX. Die products-toolbar (mit unserem Badge)
   bleibt im DOM unberuehrt — daher hilft Liquid-Rendering nur
   beim ersten Page-Load bzw. nach F5.

   Hier hooken wir uns ein:
     - Listen auf 'on:facet-filters:updated' (Canvas-Event)
     - Zaehle aktive Filter im Form
     - Badge anlegen / updaten / entfernen
   ============================================================ */
(function() {
  'use strict';

  function countActiveFilters() {
    var form = document.getElementById('facets');
    if (!form) return 0;

    var count = 0;
    var inputs = form.querySelectorAll('input[name^="filter."]');

    inputs.forEach(function(input) {
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) count++;
      } else if (input.value && input.value.trim() !== '') {
        count++;
      }
    });

    return count;
  }

  function updateBadge() {
    var btn = document.querySelector('.js-toggle-filters');
    if (!btn) return;

    var count = countActiveFilters();
    var existing = btn.querySelector('.products-toolbar__filter-badge');

    if (count > 0) {
      btn.classList.add('has-active-filters');

      if (existing) {
        existing.textContent = count;
        existing.setAttribute('aria-label', count + ' aktive Filter');
      } else {
        var badge = document.createElement('span');
        badge.className = 'products-toolbar__filter-badge';
        badge.setAttribute('aria-label', count + ' aktive Filter');
        badge.textContent = count;

        // Vor dem Toggle-Switch einfuegen, falls vorhanden
        var switchEl = btn.querySelector('.filter-toggle-switch');
        if (switchEl) {
          btn.insertBefore(badge, switchEl);
        } else {
          btn.appendChild(badge);
        }
      }
    } else {
      btn.classList.remove('has-active-filters');
      if (existing) existing.remove();
    }
  }

  document.addEventListener('on:facet-filters:updated', updateBadge);
})();
